import styled from "styled-components";
const WorkPageDisplay = styled.div`
	// my css here
`;	export default WorkPageDisplay;
